export const FIELDS_NEWS = [
  { value: "agriculture", label: "agriculture" },
  { label: "animals", value: "animals" },
  { value: "air", label: "air" },
  { value: "food", label: "food" },
  { value: "green tech", label: "green tech" },
  { value: "renewable energy", label: "renewable energy" },
  { value: "eco-building", label: "eco-building" },
  { value: "ecological engineering", label: "ecological engineering" },
  { value: "environmental law", label: "environmental law" },
  { value: "environmental studies", label: "environmental studies" },
  { value: "ecotourism", label: "ecotourism" },
  { value: "electric vehicles", label: "electric vehicles" },
  { value: "education", label: "education" },
  { value: "equipment", label: "equipment" },
  { value: "cosmetics", label: "cosmetics" },
  { value: "planting trees", label: "planting trees" },
  { value: "plastic biodegradable", label: "plastic biodegradable" },
  { value: "renovation", label: "renovation" },
  { value: "responsible consumption", label: "responsible consumption" },
  { value: "transport", label: "transport" },
  { value: "fashion", label: "fashion" },
  { value: "household products", label: "household products" },
  { value: "science", label: "science" },
  { value: "water", label: "water" },
  { value: "waste", label: "waste" },
  { value: "forest", label: "forest" },
  { value: "climate", label: "climate" },
  { value: "ocean", label: "ocean" },
  { value: "rivers", label: "rivers" },
  { value: "birds", label: "birds" },
  { value: "fish", label: "fish" },
  { value: "biodiversity", label: "biodiversity" },
  { value: "environmental protection", label: "environmental protection" },
  { value: "greenhouse gas", label: "greenhouse gas" },
  { value: "poaching", label: "poaching" },
  { value: "sustainable development", label: "sustainable development" },
  { value: "plastic pollution", label: "plastic pollution" },
  { value: "protection of reserves", label: "protection of reserves" },
  { value: "wildlife protection", label: "wildlife protection" },
  { value: "turtles protection", label: "turtles protection" },
];

export default FIELDS_NEWS;
